const ASSISTANT_TOOLBAR_FILTER_KEY = 'assistantToolToolbar';

export type AssistantToolToolbarPreferences = {
  collapsed: boolean;
  hiddenAll: boolean;
  hiddenToolIds: string[];
};

export const DEFAULT_ASSISTANT_TOOLBAR_PREFERENCES: AssistantToolToolbarPreferences = {
  collapsed: true,
  hiddenAll: false,
  hiddenToolIds: [],
};

const asRecord = (value: unknown): Record<string, unknown> => (
  value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {}
);

const toStringArray = (value: unknown): string[] => (
  Array.isArray(value)
    ? value
      .filter((entry): entry is string => typeof entry === 'string')
      .map((entry) => entry.trim())
      .filter(Boolean)
    : []
);

export const parseAssistantToolToolbarPreferences = (
  filters: unknown,
): AssistantToolToolbarPreferences => {
  const record = asRecord(filters);
  const candidate = asRecord(record[ASSISTANT_TOOLBAR_FILTER_KEY]);
  return {
    collapsed: candidate.collapsed === false ? false : true,
    hiddenAll: candidate.hiddenAll === true,
    hiddenToolIds: toStringArray(candidate.hiddenToolIds),
  };
};

export const writeAssistantToolToolbarPreferences = (
  filters: Record<string, unknown>,
  nextPreferences: AssistantToolToolbarPreferences,
): Record<string, unknown> => ({
  ...filters,
  [ASSISTANT_TOOLBAR_FILTER_KEY]: {
    collapsed: nextPreferences.collapsed,
    hiddenAll: nextPreferences.hiddenAll,
    hiddenToolIds: [...nextPreferences.hiddenToolIds],
  },
});

export const serializeAssistantToolToolbarPreferences = (
  preferences: AssistantToolToolbarPreferences,
): string => JSON.stringify({
  collapsed: preferences.collapsed,
  hiddenAll: preferences.hiddenAll,
  hiddenToolIds: [...preferences.hiddenToolIds].sort(),
});

export const shouldApplyAssistantToolToolbarHydration = (
  serverPreferences: AssistantToolToolbarPreferences,
  pendingPreferences: AssistantToolToolbarPreferences | null,
): boolean => {
  if (!pendingPreferences) {
    return true;
  }
  return serializeAssistantToolToolbarPreferences(serverPreferences)
    === serializeAssistantToolToolbarPreferences(pendingPreferences);
};
